import React from "react";

import InfraTable from "../infraresults/infratable";

import PtQuali from "../infraresults/ptresult";

import CostsTable from "./coststable";

import { Link } from "react-router-dom";

import PrintButton from "../print_button";

/**ONLY FOR DEV**/

//import Dev from '../../../models/dev';

/**DEV END**/

export default class ResultsPage extends React.Component {
  constructor(props) {
    super(props);

    /**ONLY FOR DEV**/

    //		var x = 0;

    //		var dev = new Dev();

    //		dev.setUpDataForResults("1");

    /**DEV END**/

    this.state = {
      title_name: window.datastore.lps
        .get(this.props.match.params.placeid)
        .get("name")
    };
  }

  render() {
    return (
      <div className="pagecontainer">
        <nav className="navbar navbar-default">
          <div className="container-fluid header">
            <div>
              <ol className="breadcrumb">
                {this.props.match.params.placeid === "1" ? (
                  <li className="">
                    <a href="/">Start</a>
                  </li>
                ) : (
                  ""
                )}

                <li className="">
                  <Link
                    to={
                      "/wohnstandorte/" +
                      this.props.match.params.placeid +
                      "/addressmap"
                    }
                  >
                    Wohnstandort
                  </Link>
                </li>

                <li className="">
                  <Link
                    to={
                      "/wohnstandorte/" +
                      this.props.match.params.placeid +
                      "/infrastruktur"
                    }
                  >
                    Infrastruktur
                  </Link>
                </li>

                <li className="">
                  <Link
                    to={
                      "/wohnstandorte/" +
                      this.props.match.params.placeid +
                      "/wohnkosten"
                    }
                  >
                    Wohnkosten
                  </Link>
                </li>

                <li className="">
                  <Link
                    to={
                      "/wohnstandorte/" +
                      this.props.match.params.placeid +
                      "/taeglichewege"
                    }
                  >
                    Mobilität
                  </Link>
                </li>

                <li className="active">Ergebnis</li>

                {this.props.match.params.placeid === "1" ? (
                  <li className="not-active">Vergleichsstandort</li>
                ) : (
                  ""
                )}
              </ol>
            </div>
          </div>
        </nav>

        <div className="container-fluid normal-page">
          <h4>{this.state.title_name}</h4>

          <h3>Zusammenfassung für den Standort</h3>

          <span className="help-block">
            Hier sehen sie die Zusammenfassung der Ergebnisse, d.h.
            Infrastruktur und Kosten, für den gewählten Standort.
          </span>

          <hr />

          <div className="results-page-narrow">
            <Results placeid={this.props.match.params.placeid} />
          </div>

          <div className="btn-infra-controls">
            <PrintButton enabled={true} />

            <Link to={"/wohnstandorte/2/addressmap"}>
              <button className="btn btn-default btn-primary right-button">
                MIT ANDEREM STANDORT VERGLEICHEN
              </button>
            </Link>
          </div>

          <div className="help-block smalltext">
            <p />
            Sämtliche Daten und Informationen wurden sorgfältig ermittelt. Es
            kann jedoch keine Garantie für die Richtigkeit, Vollständigkeit und
            Aktualität der Angaben übernommen werden. Datenquellen: GIP, VAO, basemap.at, OSM, iSPACE
          </div>
        </div>
      </div>
    );
  }
}

class Results extends React.Component {
  constructor(props) {
    super(props);

    this.lp = window.datastore.lps.get(this.props.placeid);
  }

  render() {
    return (
      <div>
        <h4>Wohn & Mobilitätskosten</h4>

        <span className="help-block">
          Basierend auf eingegebenen Wohnkosten und Wegen
        </span>

        <div className="row">
          <div className="col-xs-12">
            <CostsTable placeid={this.props.placeid} />
          </div>
        </div>

        <h4>Infrastruktur</h4>

        <div className="row">
          <div className="col-xs-12">
            <div className="panel panel-default">
              <div className="panel-body">
                <InfraTable
                  routes={this.lp.get("targetroutes")}
                  traveltimescenter={this.lp.get("traveltimescenter")}
                />

                <PtQuali ptquali={this.lp.get("ptquali")} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/react_components/livingplaceprocess/results/lp_results_page.js